import Announcement from '../Settings/Announcement/Announcement';

function AnnouncementPage(): JSX.Element {
  return <Announcement />;
}

export default AnnouncementPage;
